import { IconChevronRight, IconCat } from "@tabler/icons-react";
import { get_image_url } from "#api";
import { useNavigate } from "react-router-dom";
function AnimalListItem({ animal }) {
  const navigate = useNavigate();
  return (
    <div
      key={animal.animalId}
      onClick={() => navigate(`/animal/${animal.animalId}`)}
      className="border border-gray-400 p-4 shadow-md rounded-md flex gap-4"
    >
      <div>
        {animal?.images && animal?.images.length > 0 ? (
          <img src={get_image_url(animal.images[0])} alt="..." />
        ) : (
          <div className="flex items-center justify-center h-full">
            <IconCat className="h-8 w-8" />
          </div>
        )}
      </div>
      <div>
        <div className="font-semibold text-primary-600">{animal.name}</div>
        <div className="flex items-center gap-2 text-sm text-gray-400">
          <div>{animal.color}</div>
          <div>{animal.coat}</div>
        </div>
      </div>
      <div className="text-gray-400 hover:text-gray-600 flex items-center ms-auto">
        <IconChevronRight />
      </div>
    </div>
  );
}
export default AnimalListItem;
